var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActionOppsPointsOfLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 88 100",
    style: {
      enableBackground: "new 0 0 88 100"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FEFEFE;}\n\t.st1{fill:#7DBE19;}\n\t.st2{fill:#2A80C8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x35_lnPgZ.tif"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.1,50.1c0-5-4-9-9-9c-5,0-9.1,4.1-9.1,9.1c0,5,4.1,9,9.1,9C49.1,59.2,53.1,55.1,53.1,50.1z M21.3,60.1 c0,3.1,2.4,5.5,5.4,5.5c3,0,5.4-2.4,5.4-5.4c0-3.1-2.4-5.5-5.5-5.5C23.6,54.7,21.3,57.1,21.3,60.1z M21.3,40.1 c0,3.1,2.4,5.5,5.5,5.5c3,0,5.4-2.4,5.4-5.4c0-3.1-2.4-5.5-5.5-5.5C23.6,34.7,21.3,37,21.3,40.1z M49.5,70.2c0-3-2.4-5.4-5.4-5.4 c-3.1,0-5.5,2.4-5.5,5.4c0,3,2.5,5.4,5.4,5.5C47.1,75.7,49.5,73.3,49.5,70.2z M56,60.1c0,3.1,2.4,5.5,5.4,5.5c3,0,5.4-2.4,5.5-5.4 c0-3-2.4-5.5-5.5-5.5C58.4,54.7,56.1,57.1,56,60.1z M44.1,24.6c-3,0-5.5,2.5-5.5,5.5c0,3,2.5,5.4,5.5,5.4c3,0,5.4-2.4,5.4-5.4 C49.5,27,47.2,24.6,44.1,24.6z M56,40.1c0,3,2.4,5.4,5.4,5.4c3,0,5.5-2.4,5.5-5.4c0-3-2.5-5.5-5.5-5.5C58.4,34.7,56,37.1,56,40.1z  M78.9,67.8c0-2.3-1.9-4.2-4.2-4.2c-2.3,0-4.3,1.9-4.3,4.3c0,2.3,2,4.2,4.3,4.2C77,72,78.9,70.1,78.9,67.8z M39.9,14.7 c0,2.3,1.8,4.2,4.1,4.3c2.3,0.1,4.3-1.9,4.3-4.3c0-2.3-1.9-4.2-4.2-4.2C41.7,10.6,39.9,12.4,39.9,14.7z M44.1,81.3 c-2.3,0-4.2,1.8-4.3,4.1c0,2.4,1.9,4.3,4.2,4.3c2.3,0,4.2-1.9,4.2-4.2C48.3,83.1,46.5,81.3,44.1,81.3z M78.9,32.5 c0-2.3-1.9-4.2-4.2-4.2c-2.4,0-4.3,1.9-4.3,4.2c0,2.3,1.9,4.2,4.2,4.2C77,36.7,78.9,34.8,78.9,32.5z M17.6,67.8 c0-2.4-1.8-4.2-4.2-4.2c-2.4,0-4.2,1.9-4.2,4.3c0,2.3,1.9,4.2,4.2,4.2C15.8,72,17.6,70.2,17.6,67.8z M17.6,32.6 c0-2.4-1.7-4.3-4.1-4.3c-2.4-0.1-4.3,1.7-4.3,4.1c0,2.5,1.8,4.4,4.2,4.4C15.8,36.7,17.6,34.9,17.6,32.6z M87.7,73.9 c0-1.3-1.1-2.4-2.3-2.4c-1.3,0-2.5,1.1-2.5,2.4c0,1.3,1.1,2.4,2.4,2.4C86.5,76.4,87.7,75.3,87.7,73.9z M85.3,28.7 c1.3,0,2.4-1.1,2.4-2.4c0-1.4-1.1-2.4-2.5-2.4c-1.3,0-2.4,1.1-2.4,2.4C82.8,27.7,83.9,28.7,85.3,28.7z M44,100.1 c1.4,0,2.4-1,2.4-2.4c0-1.3-1-2.3-2.4-2.3c-1.4,0-2.5,1.1-2.4,2.4C41.7,99,42.7,100.1,44,100.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.3,73.3c0.3-0.1,0.3-0.5,0.5-0.8c0.6-0.9,1.7-1.3,2.8-1c1,0.3,1.6,1.2,1.6,2.3c0,1.1-0.6,2-1.7,2.3 c-1,0.3-2.1-0.1-2.7-0.9c-0.2-0.3-0.2-0.7-0.6-0.9C0.3,74.1,0.3,73.7,0.3,73.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.5,0.1c0.9,0.5,1.8,1,1.9,2.3c0.1,1.3-0.7,2.4-2,2.6c-1.1,0.2-2.3-0.5-2.7-1.6c-0.4-1.2,0.2-2.5,1.4-3 c0.2-0.1,0.4,0,0.5-0.3C44,0.1,44.3,0.1,44.5,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.3,25.9c0.5-0.8,0.9-1.7,2-1.9c1.2-0.3,2.4,0.4,2.9,1.5c0.4,1.1-0.1,2.4-1.2,3c-1.1,0.5-2.4,0.2-3.1-0.8 c-0.2-0.3-0.2-0.7-0.5-0.9C0.3,26.5,0.3,26.2,0.3,25.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.1,50.1c0,5-4,9-9,9.1c-4.9,0-9-4-9.1-9c0-5,4-9.1,9.1-9.1C49.1,41.1,53.1,45.1,53.1,50.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.3,60.1c0-3,2.4-5.4,5.4-5.4c3.1,0,5.5,2.4,5.5,5.5c0,3-2.4,5.4-5.4,5.4C23.7,65.6,21.2,63.2,21.3,60.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.3,40.1c0-3,2.4-5.4,5.4-5.4c3.1,0,5.5,2.4,5.5,5.5c0,3-2.4,5.4-5.4,5.4C23.7,45.5,21.2,43.1,21.3,40.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.5,70.2c0,3.1-2.4,5.5-5.5,5.5c-3,0-5.4-2.5-5.4-5.5c0-3,2.5-5.5,5.5-5.4C47.1,64.8,49.5,67.1,49.5,70.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,60.1c0-3,2.4-5.4,5.4-5.4c3,0,5.5,2.5,5.5,5.5c0,3-2.5,5.4-5.5,5.4C58.4,65.6,56,63.2,56,60.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.1,24.6c3.1,0,5.4,2.4,5.4,5.5c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.5-5.4C38.6,27.1,41,24.6,44.1,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,40.1c0-3.1,2.3-5.4,5.4-5.5c3.1,0,5.5,2.4,5.5,5.5c0,3-2.5,5.4-5.5,5.4C58.4,45.5,56.1,43.2,56,40.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.9,67.8c0,2.3-1.9,4.2-4.2,4.2c-2.3,0-4.2-1.9-4.3-4.2c0-2.3,1.9-4.3,4.3-4.3C77,63.6,78.9,65.4,78.9,67.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.9,14.7c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2c0,2.3-2,4.3-4.3,4.3C41.7,19,39.8,17.1,39.9,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.1,81.3c2.3,0,4.2,1.9,4.2,4.2c0,2.3-1.9,4.2-4.2,4.2c-2.3,0-4.3-1.9-4.2-4.3 C39.9,83.1,41.8,81.2,44.1,81.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.9,32.5c0,2.3-1.9,4.2-4.2,4.2c-2.3,0-4.2-1.8-4.2-4.2c0-2.4,1.9-4.3,4.3-4.2C77,28.3,78.9,30.1,78.9,32.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17.6,67.8c0,2.4-1.8,4.2-4.1,4.2c-2.4,0-4.2-1.8-4.2-4.2c0-2.4,1.9-4.3,4.2-4.3 C15.8,63.6,17.6,65.4,17.6,67.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17.6,32.6c0,2.3-1.9,4.1-4.1,4.1c-2.5,0-4.3-1.9-4.2-4.4c0-2.3,1.9-4.1,4.3-4.1 C15.9,28.3,17.7,30.2,17.6,32.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.7,73.9c0,1.3-1.1,2.4-2.5,2.4c-1.3,0-2.4-1.2-2.4-2.4c0-1.3,1.2-2.5,2.5-2.4 C86.6,71.5,87.7,72.6,87.7,73.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.3,28.7c-1.4,0-2.5-1-2.5-2.4c0-1.3,1-2.4,2.4-2.4c1.4,0,2.5,1,2.5,2.4C87.7,27.7,86.6,28.7,85.3,28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44,100.1c-1.3,0-2.4-1-2.4-2.4c0-1.4,1.1-2.4,2.4-2.4c1.3,0,2.4,1,2.4,2.3C46.5,99,45.4,100.1,44,100.1z"
  })))));
}

export default SvgActionOppsPointsOfLight;